import React, { useCallback } from 'react';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import { UncontrolledCollapse } from 'reactstrap';
import * as modalType from '../modal/modalTypes';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import * as DisplaySSR from '../../data/displaySSR';

const PassengerSummary = (props) => {
    let { data, onShowModal, flightDetail, allSSR, dataInbound,terminatorPax} = props    

    //Callback modal with modal type    
    const onClick = useCallback(e =>    {
        return onShowModal(modalType.PASSENGER, flightDetail)        
    });         

    // Inbound Passenger Modal Popup 
    const onClickInbound = useCallback(e =>  {
        return onShowModal(modalType.PASSENGERINBOUND, flightDetail)        
    });
    const onClickTerminator = useCallback(e =>  {
         return onShowModal(modalType.PASSENGERTERMINATOR, flightDetail)        
     });
    var inboundFltNumTesting = flightDetail.FltNumInbound;
    var passInboundFltTesting = flightDetail.PassengerDetails;
    
    let { totalPax } = 0

    //Default value (temp) for verifieid and boarded pax
    let { verifiedPax, boardedPax } = []

    // inbound verified pax and boarded pax
    let { verifiedInPax, boardedInPax } = []
    let { verifiedTerminatorPax, boardedTerminatorPax } = []
    // total inbound pax
    let { totalPaxInbound,totalPaxTerminator } = 0
    let { inboundSSR, outboundSSR,terminatorSSR } = '--'
    let isTerminatorFlight = flightDetail.TerminatorFlight > 0
    if(flightDetail.TerminatorFlight)
    {
        //console.info("flightdetail whole isTerminatorFlight",isTerminatorFlight 
        //+ "InboundFltnum" + flightDetail.FltNumInbound+ "OutboundFltnum"+ flightDetail.FltNumOutbound)
    }

    //Separate inbound and outbound SSR by direction: 1 for inbound, 2 for outbound
    if (allSSR != null) {

        if (!isTerminatorFlight){
            inboundSSR = allSSR.filter(
                pax =>
                    pax.Direction == 1
            )
            outboundSSR = allSSR.filter(
                pax =>
                    pax.Direction == 2
            )
        }

        else{
          terminatorSSR = allSSR.filter(
            pax =>
                pax.Direction == 2
        )      
        }
    }

    let isHeadStart = !flightDetail.DepAirportInbound;// it should be null/ if null then true

    //console.info("bug", isHeadStart + "flightDetail.DepAirportInbound" 
    //+ flightDetail.DepAirportInbound
    //+"fltnumIN"+ flightDetail.FltNumInbound + "fltOUT" + flightDetail.FltNumOutbound);   

    const displaySSR = DisplaySSR.displaySSR
    //Filter verified passengers and boarded passengers
    if (data != null && !isTerminatorFlight) {
        //console.info("3 data", data);
        verifiedPax = data.filter(pax => pax.Confirmed > 0 && pax.VerifiedTravelDocs != '').length  //Verified passenger count
        //console.info("3 verifiedPax", verifiedPax);
        boardedPax = data.filter(pax => pax.Confirmed > 0 && pax.LiftStatus == 2).length  //Boarded passenger count
        totalPax = data.filter(pax => pax.Confirmed > 0).length
        //totalPax = data.length  //Total passenger count
	} else {
        totalPax = '--'
        boardedPax = '--'
        verifiedPax = '--'
    }

    //Filter verified passengers and boarded passengers for inbound
    if (dataInbound != null && !isTerminatorFlight) {
        //console.info("3 data", data);
        verifiedInPax = dataInbound.filter(pax => pax.Confirmed > 0 && pax.VerifiedTravelDocs != '').length  //Verified passenger count
        //console.info("3 verifiedPax", verifiedInPax);
        boardedInPax = dataInbound.filter(pax => pax.Confirmed > 0 && pax.LiftStatus == 2).length  //Boarded passenger count
        totalPaxInbound = dataInbound.filter(pax => pax.Confirmed > 0).length
        //totalPax = data.length  //Total passenger count
	} else {
        totalPaxInbound = '--'
        boardedInPax = '--'
        verifiedInPax = '--'
    }
    if(terminatorPax != null && isTerminatorFlight) {
        let confirmedTerminatorPax = terminatorPax.filter(passenger => passenger.Confirmed > 0);    
        verifiedTerminatorPax = confirmedTerminatorPax.filter(passenger => passenger.VerifiedTravelDocs != '').length;//Verified passenger count
        boardedTerminatorPax = confirmedTerminatorPax.filter(passenger => passenger.LiftStatus == 2).length;//Boarded passenger count
        totalPaxTerminator = confirmedTerminatorPax.length;
    } else {
        totalPaxTerminator = '--';
        boardedTerminatorPax = '--';
        verifiedTerminatorPax = '--';
    }
    

    //need to change here for boarded for inbound boarded started
function boardingStatusInbound() {   
    //console.info("3 flightDetail.LegHashKeyInbound", flightDetail.LegHashKeyInbound);
    return (
        <span>
            <label>Boarded</label>
            <div key={flightDetail.LegHashKeyInbound} className="passengerCount">
                {boardedInPax} / <b>{totalPaxInbound}</b>
            </div>
        </span>
    ) 
}
//Terminator Flight Boarding Status - //The number of boarded passengers for the Terminator flight is displayed, followed by the total number of passengers.
function boardingStatusTerminator() {
    return (
        <span>
            <label>Boarded</label>
            <div key={flightDetail.LegHashKeyInbound} className="passengerCount"> 
                {boardedTerminatorPax} / <b>{totalPaxTerminator}</b>
            </div>
        </span>
    );
}

// Verified inbound passengers
function verifiedStatusInbound() {
    //Verified passengers are only required when a flight is transboarder
    if (flightDetail.TransborderOutbound == 1) {
        return (
            <Grid item xs={6}>
                <label>Verified</label>
                <div className="passengerCount">
                    {verifiedInPax} / <b>{totalPaxInbound}</b>
                </div>
            </Grid>
        )
    } else {
        return (
            <Grid item xs={6}>
                <label>Verified</label>
                <div className="passengerCount">
                    --
                </div>
            </Grid>
        )
    }
}
// This function returns the verification status for the Terminator flight.
function verifiedStatusTerminator() {
    // Initialize passengerCount with '--'. This will be displayed when there are no passengers or the count is not available.
    let passengerCount = '--';

    // If the flightDetail.TransborderOutbound property is 1, it means the flight is transboarder
    if (flightDetail.TransborderOutbound == 1) {
        passengerCount = `${verifiedTerminatorPax} / ${totalPaxTerminator}`;
    }
    return (
        <Grid item xs={6}>
            <label>Verified</label>
            <div className="passengerCount">
                {passengerCount}
            </div>
        </Grid>
    );
}


//ends

    function boardingStatus() {
        // if (boardedPax != null && boardedPax > 0) {              Requirement Oct 11
        return (
            <span>
                <label>Boarded</label>
                <div key={flightDetail.LegHashKeyOutbound} className="passengerCount">
                    {boardedPax} / <b>{totalPax}</b>
                </div>
            </span>
        )
        // }
    }

    function verifiedStatus() {
        //Verified passengers are only required when a flight is transboarder
        if (flightDetail.TransborderOutbound == 1) {
            //console.info("Verified",flightDetail)
            return (
                <Grid item xs={6}>
                    <label>Verified</label>
                    <div className="passengerCount">
                        {verifiedPax} / <b>{totalPax}</b>
                    </div>
                </Grid>
            )
        } else {
            //console.info("Verified",flightDetail)
            return (
                <Grid item xs={6}>
                    <label>Verified</label>
                    <div className="passengerCount">
                        --
                    </div>
                </Grid>
            )
        }
    }

    //Default inbound and outbound ssr for use


    //Retrieve SSR Details and output a string
    function ssrDetails(directionSSR) {
        let arr = []                                    //new array to receive all code and count. Format: [{code: INFT, count: 1}, {code: WHCL, count: 2}]
        if (directionSSR != null) {
            directionSSR.map(pax => {                   //Parse all SSR per passenger, 'pax' may contain multiple SSR
                pax.SSRDetails.map(ssrcode => {         //Parse per SSR per passenger, 'ssrcode' is each SSR
                    if (displaySSR.includes(ssrcode.SSRCode)) {    //Exclude bag from SSR and push the rest to arr
                        let obj = {
                            code: ssrcode.SSRCode,
                            count: Number(ssrcode.Count)
                        }
                        arr.push(obj)
                    }
                })
            })
            const groupBySSR = arr.reduce((ssr, perssr) => {     //Build grouping for SSR codes and count for all passengers                                                                                                                                                                                                                                                                                                                    
                ssr[perssr.code] = ssr[perssr.code] + 1 || 1;    //Sum up unique SSR code with its count     
                return ssr                                       //Format: {'INFT', '2'}{'WHCL', '1'}                   
            }, {});
            const final = Object.entries(groupBySSR).map(([key, value], i) => {        //Map key and value                
                return (
                    <span key={flightDetail.LegHashKeyInbound + flightDetail.LegHashKeyOutbound + value + i}>{key} ({value.toString()}) </span> //Return string
                );
            })
            if (arr.length > 0) {
                return final        //Return final input. Format: INFT (1)
            } else {
                return '--'
            }
        } else {
            return '--'
        }
    }

    return (
        <div>
            <ExpansionPanel className="passengerSummary">
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >Details </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                <Grid container spacing={2}>
                    <Grid xs={6} container direction="row" justifyContent="space-around"> 
                    {isTerminatorFlight ? verifiedStatusTerminator() : verifiedStatusInbound()}                       
                        <Grid item xs={6}>
                        {isTerminatorFlight ? boardingStatusTerminator() : boardingStatusInbound()}    
                        </Grid>
                    </Grid>                  
                    
                    <Grid xs={6} container direction="row" justifyContent="space-around">
                        {verifiedStatus()}
                        <Grid item xs={6}>
                        {boardingStatus()}
                        </Grid>
                    </Grid>                    
                </Grid>
                    <div><hr className="separator clear" /></div>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <label>Inbound SSR</label>
                            <div>
                            {isTerminatorFlight ? ssrDetails(terminatorSSR) : ssrDetails(inboundSSR)} 
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <label>Outbound SSR</label>
                            <div>
                                {ssrDetails(outboundSSR)}
                            </div>
                        </Grid>
                    </Grid>
                    <div><hr className="separator clear" /></div>
                    {isTerminatorFlight||!isHeadStart ? <a onClick={isTerminatorFlight ? onClickTerminator : onClickInbound} className="floatLeft"> All Passengers </a> : <span className="floatLeft"> </span>}

                    {!isTerminatorFlight ? <a onClick={onClick} className="floatRight">All passengers</a> : <span className="floatRight">&nbsp;</span>}
                    <div className="clear"></div>                    
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </div>
    )
}

export default PassengerSummary